import { render } from "./TradingRecord.vue?vue&type=template&id=5ac841da&scoped=true"
import script from "./TradingRecord.vue?vue&type=script&lang=js"
export * from "./TradingRecord.vue?vue&type=script&lang=js"

import "./TradingRecord.vue?vue&type=style&index=0&id=5ac841da&scoped=true&lang=css"
import "./TradingRecord.vue?vue&type=style&index=1&id=5ac841da&lang=scss"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac841da"]])

export default __exports__